import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DateElement, ScreensQuestionResource } from '@Components/mras/core';
import { MatDatepicker } from '@angular/material/datepicker';
import _moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { Moment} from 'moment';
import { FormControl } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { SharedModule } from '@Shared/shared.module';
import { MrasMaskDate2Directive } from './mras-mask-date.directive';

const moment = _moment;
export const MY_FORMATS = {
    parse: {
        dateInput: ['YYYY-MM', 'MM/YYYY', 'MM-YYYY']
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MM/YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
@Component({
    selector: 'jhi-short-date-input',
    templateUrl: './short-date-input.component.html',
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
    imports: [SharedModule, MrasMaskDate2Directive]
})
export class ShortDateInputComponent implements OnInit {
    @Input() question: ScreensQuestionResource;
    @Input()
        summaryMode: boolean;

    _value: string;
    formattedDate: string;
    
    @Input() set value(val: string) {
        if (!val || val === '') {
            this._value = null;
            this.formattedDate = null;
            this.dateValue.setValue(null);
            return;
        }

        const d = new Date(val);
        this.formattedDate = d.toISOString().substring(0, 10) + d.toISOString().substring(10,);          
        
        this._value = moment(val).format(this.dateFormat);
        this.dateValue.setValue(moment.utc(this.formattedDate));
    }
    get value() {return this._value;}
        
    @Output()
        valueChange = new EventEmitter<string>();
    @Input()
        granularity: DateElement;

    

    @Input()
        placeholder: string;
    @Input()
        disabled: boolean;
    @Input()
        enableChangeButton: boolean;

    @Output()
        action = new EventEmitter();

    dateValue= new FormControl();

    _minDate: string;
    _maxDate: string;

    get minDate(){return this._minDate;}
    @Input() set minDate(dateString: string) {
        if (dateString == null) {
            return;
        }
        this._minDate = dateString;
    }

    get maxDate(){return this._maxDate;}
    @Input() set maxDate(dateString: string) {
        if (dateString == null) {
            this._maxDate = moment(new Date()).format("MM/YYYY");
        }
        this._maxDate = dateString;
    }


    dateFormat = "YYYY-MM-DD";

    pickerFieldName: string;

    ngOnInit(): void {
        if (this.granularity === DateElement.MONTH) {
            this.dateFormat = "YYYY-MM";
        }

        if (!this._maxDate || this._maxDate === null || this._maxDate === '') {
            this._maxDate = moment(new Date()).format(this.dateFormat);
        }

        if (this.formattedDate != null) {    
            const newDate = new Date(this.formattedDate);        
            newDate.setDate( new Date(this.formattedDate).getDate() + 1);
            this.dateValue.setValue(moment.utc(this.formattedDate));
        }
    }

    setMonthAndYear(normalizedMonthAndYear: Moment, datepicker: MatDatepicker<Moment>) {     
        this.dateValue.setValue(moment(normalizedMonthAndYear).format(this.dateFormat));
        this.onDateChange();
        datepicker.close();
    }

    // on blur of the field, validate the field manually as Validations.minDate and maxDate doesnt work on clicking the date popup calendar.
    onDateChange() {
        if (!this.summaryMode) {

            if (!this.dateValue.valid) {
                return;
            }


            if (this.question.invalid) {
                this.question.invalid = false;
            }

            if (this.value && this.value !== '') {
                this.valueChange.emit(null);
            }
            
            this.value = moment(this.dateValue.value).format(this.dateFormat);
            this.valueChange.emit(this.value);
            this.action.emit(null);
        }
    }
}
